
import LineChart from "components/charts/LineChart";
import { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import { getChartsData } from "services/dashboardService";
import { toast } from 'react-toastify';
import { formateDate } from "utils/formatDate";
import moment from "moment";
import { handleLoader, handleNotFound } from "redux/counterSlice";
import { useDispatch } from "react-redux";
import { Calendar } from "primereact/calendar";
import { Controller, useForm } from "react-hook-form";

const Dashboard = () => {
    const dispatch = useDispatch();
    const {
        handleSubmit,
        setValue,
        control,
        setError,
        clearErrors,
        getValues,
        formState: { errors },
    } = useForm<any>()
    const [options, setOptions] = useState({
        chart: {
            id: "basic-bar",
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: []
        }
    })
    const [series, setSeries] = useState([
        {
            name: "",
            data: []
        }
    ])
    const [ldOptions, setLdOptions] = useState({
        chart: {
            id: "basic-bar",
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: []
        },
        tooltip: {
            y: {
                formatter: (val: any) => Math.round(val)
            }
        },
    })
    const [ldSeries, setLdSeries] = useState([
        {
            name: "",
            data: []
        }
    ])
    const [dChartOption, setDChartOption] = useState<any>({
        labels: [],
        legend: {
            position: 'bottom',
        },

        plotOptions: {
            pie: {
                donut: {
                    size: '54%'
                }
            }
        }

    })

    const getInitialStartDate = () => {
        return new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    }
    const getInitialEndDate = () => {
        return new Date()
    }

    const [dChartSeries, setDChartSeries] = useState([])
    const [startDate, setStartDate] = useState(getInitialStartDate());
    const [endDate, setEndDate] = useState(getInitialEndDate());
    const [isRefresh, setIsRefresh] = useState(false);

    useEffect(() => {
        dispatch(handleNotFound(false));
        let data: any = {}
        data.from_date = formateDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
        data.to_date = formateDate(new Date())
        data.user_name = localStorage.getItem("username");
        handleDate(data)
        defaultDate();
    }, [])

    const defaultDate = () => {
        setValue("dates", [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
    }

    useEffect(() => {
        if (isRefresh) {
            let data: any = {}
            data.from_date = formateDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
            data.to_date = formateDate(new Date())
            data.user_name = localStorage.getItem("username");
            handleDate(data)
            setIsRefresh(false)
        }
    }, [isRefresh])

    const onSubmit = async (data: any) => {
        if (data.dates && data.dates[0] !== null && data.dates[1] === null) {
            setError('dates', { type: 'custom', message: "Please select end date also", });
        } else {
            data.from_date = formateDate(data.dates[0])
            data.to_date = formateDate(data.dates[1])
            data.user_name = localStorage.getItem("username");
            delete data.dates
            await handleDate(data)
        }
    }

    const handleDate = async (body: any) => {
        dispatch(handleLoader(true));
        try {
            // const body = {
            //     from_date: formateDate(startDate),
            //     to_date: formateDate(endDate),
            //     user_name: localStorage.getItem("username")
            // }
            const data = await getChartsData(body)
            if (data.error) {
                throw data.error
            }
            dispatch(handleLoader(false));
            setDChartOption({
                labels: data.topQueries.map((element: any) => {
                    return element.query
                })
            })
            setDChartSeries(data.topQueries.map((element: any) => {
                return element.count
            }))
            setOptions((previousState: any) => ({
                ...previousState,
                xaxis: {
                    categories:
                        data.totalQuerySearch.map((element: any) => {
                            const sDate = new Date(element.date)
                            return moment(element.date).format("MMM") + " " + sDate.getDate()
                        })
                }
            }))
            const dummy = []

            dummy.push({
                name: "query search",
                data: data.totalQuerySearch.map((element: any) => {
                    return element!.count
                })
            })
            setSeries(dummy)

            setLdOptions((previousState: any) => ({
                ...previousState,
                xaxis: {
                    categories:
                        data.likeDislike.map((element: any) => {
                            const sDate = new Date(element.date)
                            return moment(element.date).format("MMM") + " " + sDate.getDate()
                        })
                }
            }))

            const like = [{
                name: "Like",
                data: data.likeDislike.map((element: any) => {
                    return element!.like
                })
            }]

            const disLike = [{
                name: "Dislike",
                data: data.likeDislike.map((element: any) => {
                    return element!.dislike
                })
            }]

            setLdSeries([...like, ...disLike])
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const calendarRef = useRef(null);
    const startRef = useRef(null);
    const handleLabelClick = (e: any) => {
        if (calendarRef.current && (calendarRef.current as any).state.open) {
            e.preventDefault();
        }
    };
    const handleLabelClickStart = (e: any) => {
        if (startRef.current && (startRef.current as any).state.open) {
            e.preventDefault();
        }
    };

    return (
        <div className="p-4 content-wrapper">
            <div className="switch-section user-management-section">
                <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                    <h4 className="mb-0">Dashboard</h4>
                    <div className="d-flex justify-content-between align-items-center table-right-row">
                        <form className="d-flex flex-wrap align-items-start dasboard-head" onSubmit={handleSubmit(onSubmit)}>
                            <div className="table-right-first mr-3 mt-1 mb-1">
                                <Controller
                                    name="dates" // Specify the field name
                                    control={control}
                                    defaultValue={null} // Set the initial value as needed
                                    rules={{ required: "Date is required" }} // Add validation rules here
                                    render={({ field: { onBlur, onChange, value } }) => (
                                        <Calendar
                                            maxDate={new Date()}
                                            value={value}
                                            onChange={(e) => {
                                                onChange(e.value)
                                                clearErrors('dates')
                                            }}
                                            selectionMode="range"
                                            readOnlyInput
                                            showIcon
                                            hideOnRangeSelection
                                            className="user-input table-search"
                                        />
                                    )}
                                />
                                {errors.dates && <p className="text-danger mb-0">{errors.dates.message as any}</p>}
                            </div>
                            <button className="outline-active-btn mr-3 mt-1 mb-1 dashboard-submit">Submit</button>
                            <span className="refresh-btn mt-1 mb-1" onClick={() => { defaultDate(); clearErrors('dates'); setIsRefresh(true) }} title="Reset Calender">
                                <i className="fa fa-refresh"></i>
                            </span>
                        </form>
                    </div>
                </div>
                <div className="row chart-overflow">
                    <div className="col-lg-6 mb-4">
                        <div className="mixed-chart round-bg">
                            <h5 className="ps-3 pt-2">Query Search</h5>
                            <LineChart
                                options={options}
                                series={series}
                                type="bar"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4">
                        <div className="donut round-bg h-100">
                            <h5 className="mb-4 ps-3 pt-2">Top 5 Searched Queries</h5>
                            <Chart options={dChartOption} height={300} series={dChartSeries} type="donut" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="mixed-chart round-bg">
                            <h5 className="ps-3 pt-2">Feedback</h5>
                            <LineChart
                                options={ldOptions}
                                series={ldSeries}
                                type="line"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard